import { Entity } from '@/models'

export class Platform extends Entity {
  name: string;
  description: string;
  url: string;
}
